export default "__VITE_ASSET__DNLzykfn__"